export default function getDatePattern(maskDatesFormat?: boolean) {
	const locale = navigator.languages[0];
	const formatter = new Intl.DateTimeFormat(locale).formatToParts();
	return maskDatesFormat
		? formatter
				.map(function (e) {
					switch (e.type) {
						case "month":
						case "day":
							return "99";
						case "year":
							return "9999";
						case "literal":
							return e.value.replace("‏", "");
						default:
							return;
					}
				})
				.join("")
		: formatter
				.map(function (e) {
					switch (e.type) {
						case "month":
							return "MM";
						case "day":
							return "dd";
						case "year":
							return "yyyy";
						default:
							return e.value;
					}
				})
				.join("")
				.replaceAll("‏", "");
}
